import React from "react";
import Icon from "./common/Icon";
import { fmtScn } from "../utils/format";
import "./ClaimBanner.css";

// Colorful animated banner that routes to the SCN tab.
export default function ClaimBanner({ claimable, onClick }) {
  const hasClaim = claimable && !claimable.isZero();
  return (
    <button className="claim-banner" onClick={onClick}>
      <span className="cb-shine" />
      <span className="cb-coin"><Icon name="coins" size={26} /></span>
      <span className="cb-text">
        <span className="cb-title">Claim Smartcore Node</span>
        <span className="cb-sub">
          {hasClaim ? `${fmtScn(claimable)} SCN ready to claim` : "View & claim your SCN rewards"}
        </span>
      </span>
      {hasClaim && <span className="cb-pill">●</span>}
      <span className="cb-arrow">→</span>
    </button>
  );
}
